import React, { useEffect, useRef } from 'react'
import { template } from './slipTemplate';
import LetterHead from "../../../assets/images/WhatsApp Image 2024-07-23 at 2.12.37 PM.jpeg"

export default function PrintSlipTemplate({ data }) {
  const templateRef = useRef();
  useEffect(() => {
    if (templateRef.current) {
      templateRef.current.innerHTML = template(LetterHead,data);
    }
  });
  return <div ref={templateRef}></div>;
}
